import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "@apollo/client";
// components
import GetSurvey from "../queries/GetSurvey";
import SurveySectionOne from "./SurveySectionOne";
import SurveySectionTwo from "./SurveySectionTwo";
import SurveySectionThree from "./SurveySectionThree";
import Header from "./Headers/Header.js";
// reactstrap components
import { Container, Row, Nav, NavItem, NavLink, TabContent, TabPane, Card, CardBody, CardHeader } from "reactstrap";

const navLink = {
  cursor: "pointer",
};

const UserSurvey = ({ currentUserData }) => {
  const params = useParams();
  const { loading, error, data } = useQuery(GetSurvey, { variables: { surveyId: params.surveyId } });

  const [activeTab, setActiveTab] = useState("1");

  if (loading) return <div>loading</div>;
  if (error) {
    console.log("error:");
    console.log(error);
    return <p>Something Went Wrong...</p>;
  }

  return (
    <>
      <Header title={data.survey.title} description='Please complete the assigned survey below.' />
      {/* Page content */}
      <Container className='mt--7' fluid>
        {/* Table */}
        <Row>
          <div className='col'>
            <Card className='shadow-lg bg-secondary'>
              <CardHeader className='bg-secondary'>
                <Nav justified pills>
                  <NavItem>
                    <NavLink
                      className={activeTab === "1" ? "active" : ""}
                      onClick={() => {
                        setActiveTab("1");
                      }}
                      style={navLink}
                    >
                      Section 1
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={activeTab === "2" ? "active" : ""}
                      onClick={() => {
                        setActiveTab("2");
                      }}
                      style={navLink}
                    >
                      Section 2
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={activeTab === "3" ? "active" : ""}
                      onClick={() => {
                        setActiveTab("3");
                      }}
                      style={navLink}
                    >
                      Section 3
                    </NavLink>
                  </NavItem>
                </Nav>
              </CardHeader>
              <CardBody>
                <TabContent activeTab={activeTab}>
                  <TabPane tabId='1'>
                    <SurveySectionOne currentUserData={currentUserData} survey={data.survey} />
                  </TabPane>
                  <TabPane tabId='2'>
                    <SurveySectionTwo currentUserData={currentUserData} survey={data.survey} />
                  </TabPane>
                  <TabPane tabId='3'>
                    <SurveySectionThree currentUserData={currentUserData} survey={data.survey} />
                  </TabPane>
                </TabContent>
              </CardBody>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default UserSurvey;
